/**
 *  Loại phương án phân bổ
 */
export default {
  NotApproved: 1, // Chưa duyệt
  Approved: 2, // Đã duyệt
  WaitApproved: 3, // Chờ duyệt
  CantApproved: 4, // Không được duyệt
  Backup: 5, // Backup
};
